import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Button from 'components/Button/Button';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import style from './DeleteBtn.module.scss';

interface IDeleteBtn {
	idForDeletion: string;
	deleteBankSettingsBlock: (value: string) => void;
}

const DeleteBtn: React.FC<IDeleteBtn> = ({ idForDeletion, deleteBankSettingsBlock }) => {
	const { removeAllAdditionalValidationErrorsInBlock } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const handleDeleteBlock = () => {
		removeAllAdditionalValidationErrorsInBlock(idForDeletion);
		deleteBankSettingsBlock(idForDeletion);
	};

	return (
		<Button
			className={style.button}
			theme="secondary"
			onClick={handleDeleteBlock}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#bin`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="deleteSettingsButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(DeleteBtn);
